/** @format */

export const getBBAuthLink = (): string => {
  // TODO: needs ebl client id
  return `https://bitbucket.org/site/oauth2/authorize?client_id=${process.env.REACT_APP_BB_AUTH_CLIENT_ID}&response_type=code`;
};
